module.exports = __webpack_public_path__ + "media/images/flags/32/Angola-1d8a5da7b12586a3fc33b64edd593f24.png";